var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditorAddQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1181_1853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 18.8332C14.6024 18.8332 18.3333 15.1022 18.3333 10.4998C18.3333 5.89746 14.6024 2.1665 10 2.1665C5.39763 2.1665 1.66667 5.89746 1.66667 10.4998C1.66667 15.1022 5.39763 18.8332 10 18.8332Z",
    stroke: "#98BDBD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.575 7.99999C7.77092 7.44304 8.15762 6.97341 8.66663 6.67426C9.17563 6.37512 9.77408 6.26577 10.356 6.36558C10.9379 6.46539 11.4657 6.76792 11.8459 7.21959C12.2261 7.67126 12.4342 8.24292 12.4333 8.83332C12.4333 10.5 9.93333 11.3333 9.93333 11.3333",
    stroke: "#98BDBD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14.6665H10.0083",
    stroke: "#98BDBD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1181_1853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(20 0.5) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorAddQuestion);
export default __webpack_public_path__ + "static/media/editor_add_question.45e5c7758bbbe61d34d1e4a6131d1bae.svg";
export { ForwardRef as ReactComponent };